import {Service} from "../Service";

export class TickeService extends Service{
    constructor() {
        super('ticket/');
    }
    obtenerClasificaciones(){
        this.onStart();
        return this.http.get(this.getUrl(['clasificaciones']))
            .then(r => this.onData(r))
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })

    }

}